module.exports = __webpack_public_path__ + "static/images/how-it-works-1.1d6bc41c9fcbbe6b0fe3d2f65efe3664.png";